export interface IMenuItem {
  name: string
  url: string
  target?: string
  active?: boolean
  classes?: string[]
}

export const MOBILE_HEADER_MIN_WIDTH = 1100
